import { Component, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-tree-view',
    templateUrl: './tree-view.component.html',
    styleUrls: ['./tree-view.component.scss'],
    standalone: false
})
export class TreeViewComponent implements OnInit {

	private _data: any;
	public get data(): any {
		return this._data;
	}
	@Input()
	public set data(value: any) {
		this._data = value;
	}

	// @Input()
	// public childrenKeyExpression: string;

	@Input()
	public nodeTemplate: TemplateRef<any>;

  constructor() { }

  ngOnInit(): void {
  }
}
